import React from 'react'
import {Box, useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'
import PageLoader from '../../components/page-loader'
import {useOptimizelyPage} from '../../hooks/use-optimizely-page'
import ContentFallback from '../../components/optimizely/utils/contentFallback'
import {renderLayoutsSwitch} from '../../components/optimizely/utils/contentRenderer'
import {GDIDynamicContentProvider} from '../../components/optimizely/gdi/utils/gdi-dynamic-content-context'

export const WISHLIST_EMPTY_PAGE_ID = 'wishlist-page'

const WishlistEmpty = () => {
    const {data: optimizelyData, isLoading} = useOptimizelyPage(WISHLIST_EMPTY_PAGE_ID)
    /* Disable carousel viewport bleed only on desktop (lg+) so authored left
     * margins apply as a fixed gutter; keep the edge-to-edge bleed below lg. */
    const disableViewportBleed = useBreakpointValue({base: false, lg: true})

    if (isLoading) {
        return (
            <Box data-testid="wishlist-empty-page">
                <PageLoader />
            </Box>
        )
    }

    const pageContent = optimizelyData?.item || optimizelyData?.items?.[0]
    const emptyWishlist = pageContent?.EmptyWishlist ?? []

    if (emptyWishlist.length === 0) {
        return (
            <Box data-testid="wishlist-empty-page">
                <ContentFallback contentKey={WISHLIST_EMPTY_PAGE_ID} />
            </Box>
        )
    }

    return (
        <Box data-testid="wishlist-empty-page">
            <GDIDynamicContentProvider value={{disableViewportBleed: !!disableViewportBleed}}>
                {emptyWishlist.map((item, idx) => (
                    <React.Fragment key={`${item?.ContentLink?.Id ?? 'empty-wishlist'}-${idx}`}>
                        {renderLayoutsSwitch(item?.ContentLink?.Expanded)}
                    </React.Fragment>
                ))}
            </GDIDynamicContentProvider>
        </Box>
    )
}

export default WishlistEmpty
